@if (contentlet$ | async; as contentlet) {
<div class="dot-cms-html-content default-web-page-content-class">
  @if (setAttribute()) {
  <custom-dot-editable-text [fieldName]="'body'" [contentlet]="contentlet" [format]="'html'" [mode]="'full'" />
  } @else {
  <div
    dotCmsSetAttributes
    [identifier]="contentlet.identifier"
    [mode]="'full'"
    [fieldName]="'body'"
    [setAttribute]="setAttribute()"
    class="dot-cms-html-content default-web-page-content-class"
    [ishServerHtml]="contentlet.body"
  ></div>
  }
</div>
}
